import { axiosInstance } from "./api_instance";

export default async function activateUserAPI(activationToken) {
    try {
        const response = await axiosInstance.post("/auth/activate", { "activationToken": activationToken })
       
        return response.data.success.message
    } catch (error) {
        let msg = await error.response.data.error.message
       
        return msg
    }
} 